import { FC } from "react";
import { MainScreenFilter, TeamContext } from "../../../types/common";
import { TournamentTableMiniWidget } from "../../stats/tournament-table/TournamentTableMiniWidget";
import { Tabs } from "antd";
import type { TabsProps } from 'antd';
import { PlayersStatsMiniWidget } from "../../stats/players/PlayersStatsMiniWidget";

interface MainScreenStatsWigdetProps {
    statsFilters?: MainScreenFilter[];
    topTeams?: number;
    bottomTeams?: number;
    prevMatches?: number;
    teamName?: TeamContext;
}

export const MainScreenStatsWigdet: FC<MainScreenStatsWigdetProps> = (
    { topTeams, bottomTeams, teamName, statsFilters }
) => {
    const statItems = statsFilters.map((filter) => {
        const { tournamentId, seasonId, teamId } = filter;
        return (
            <div key={`${tournamentId}-${seasonId}-${teamId}`} className="flex flex-col items-center w-full mx-auto">
                <div className="flex flex-col items-start w-full sm:px-2 sm:justify-center sm:flex-row gap-2 sm:gap-4 md:gap-6">
                    <TournamentTableMiniWidget
                        tournamentId={tournamentId}
                        seasonId={seasonId}
                        teamId={teamId}
                        topTeams={topTeams}
                        bottomTeams={bottomTeams}
                        teamName={teamName}
                    />
                    <PlayersStatsMiniWidget
                        tournamentId={tournamentId}
                        seasonId={seasonId}
                        teamId={teamId}
                        totalPlayers={topTeams + bottomTeams + 1}
                        teamContext={teamName}
                    />
                </div>
            </div>
        );
    });

    if (statItems.length === 0) {
        return null;
    }

    if (statItems.length === 1) {
        return <div className="py-4 sm:py-8">{statItems[0]}</div>;
    }

    const items: TabsProps['items'] = statItems.map((item, index) => {
        return {
            key: index.toString(),
            label: statsFilters?.[index]?.title || `Турнир ${index + 1}`,
            children: item
        };
    });

    return (
        <div className="px-3 py-4">
            <Tabs defaultActiveKey={`0`} items={items} centered size="large" classNames={{
                item: "sm:!text-xl font-bold",
                indicator: "sm:!h-2 rounded-full"
            }} />
        </div>
    );
}